import { useLocation } from "react-router-dom";
import CreatorShell from "@/components/creator/CreatorShell";
import StartCard from "@/components/bgv/StartCard";
import BgvHistory from "@/components/bgv/BgvHistory";

const HOW = [
  ["1", "From your own voice", "Your lead turned into harmony lines in your key — starts with a simple harmony a 3rd above, up to 4 parts. Male, female, mixed or a full gospel choir. Free."],
  ["2", "AI choir", "A choir sung over your music by AI (uses ELPM credits), cut to the sections you choose."],
  ["3", "Every part separate", "Each singer gets its own level, pan and reverb — save it as a song or download every part as 24-bit WAV."],
];

function initialPick(search) {
  const p = new URLSearchParams(search);
  const title = p.get("title") || "";
  if (p.get("song")) return { tab: "songs", pick: { kind: "library", id: p.get("song"), label: title || "This song", has_music: true } };
  if (p.get("enhance")) return { tab: "enhanced", pick: { kind: "enhance", id: p.get("enhance"), version: p.get("version") || "polished", label: title || "This vocal" } };
  return { tab: "songs", pick: null };
}

/** `/create/background-singers` — pick a lead vocal, choose how the singers are made, and see what you've made before. */
export default function BackgroundSingersPage() {
  const location = useLocation();
  return (
    <CreatorShell testId="bgv-page" back="/create" title="Background Singers" subtitle="Harmonies and a gospel choir behind your lead — every singer on its own part.">
      <div className="grid gap-6 lg:grid-cols-[1.2fr_1fr]">
        <StartCard initial={initialPick(location.search)} />
        <div className="space-y-6">
          <section className="rounded-3xl border border-white/[0.08] bg-[#0a0d1c]/60 p-5 sm:p-7">
            <h2 className="font-display text-base font-semibold md:text-lg">How it works</h2>
            <ul className="mt-4 space-y-4">
              {HOW.map(([k, t, b]) => (
                <li key={k} className="flex gap-3">
                  <span className="grid h-7 w-7 flex-shrink-0 place-items-center rounded-lg bg-violet-400/15 font-mono text-[12px] font-bold text-violet-200">{k}</span>
                  <span><span className="block text-[14px] font-medium">{t}</span><span className="block text-[12px] leading-relaxed text-white/50">{b}</span></span>
                </li>
              ))}
            </ul>
            <p className="mt-5 text-[12px] leading-relaxed text-white/45">Works best on a clean lead vocal. Singers made from your voice keep your timing and phrasing; the male and female colours come from reshaping your own voice.</p>
          </section>
          <BgvHistory />
        </div>
      </div>
    </CreatorShell>
  );
}
